import PageTitle from '../components/PageTitle'

function StoreHeading() {
  return (
    <div className="pt-4">
      <PageTitle text="Adopta tu mascota" />
    </div>
  )
}

export default StoreHeading
